import React, { useState } from 'react';
import styles from './style.module.scss';

const FileUploader = ({
  onFileSelect,
  buttonText = 'Choose a file',
  acceptedFileTypes = '*',
}) => {
  const [fileName, setFileName] = useState(null);

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      if (onFileSelect) {
        onFileSelect(file);
      }
    }
  };

  return (
    <div className={styles.fileUploader}>
      <label htmlFor="file" className={styles.fileLabel}>
        {fileName || buttonText}
        <input
          id="file"
          type="file"
          onChange={handleFileChange}
          className={styles.fileInput}
          accept={acceptedFileTypes}
        />
      </label>
    </div>
  );
};

export default FileUploader;
